import React from "react";
import { useCallback } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allBookingsListReducer } from "../slice";
import { useEffect } from "react";
import Loader from "../../Components/Loader";
import Paginations from "../../Components/Pagination";
import moment from "moment";
import { Link } from "react-router-dom";

function MyBooking() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [modalName, setModalName] = useState("");
  const [status, setStatus] = useState();

  const handleShow = () => {
    setShow(!show);
  };
  const handlePage = (value) => {
    setPage(value);
  };

  const list = useSelector((store) => store.main.allBookingsList);

  const getList = useCallback(() => {
    setLoading(true);
    dispatch(
      allBookingsListReducer({
        page: page,
        limit: 12,
        orderStatus: status,
      })
    ).then((res) => {
      if (res?.payload?.code === 1) {
        setLoading(false);
      }
    });
  }, [dispatch, page, status]);

  useEffect(() => {
    getList();
  }, [getList]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
            <h3>My Booking</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetueradipiscing elit. Aenean
              commodo ligula eget dolor. Aenean massa.
            </p>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
            <div className="detailTabs mt-4">
              <ul
                className="nav nav-pills group-nav px-3 gap-3"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className={!status ? "nav-link active" : "nav-link"}
                    onClick={() => {
                      setStatus();
                    }}
                  >
                    all
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={status === 1 ? "nav-link active" : "nav-link"}
                    onClick={() => {
                      setStatus(1);
                    }}
                  >
                    on-going
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={status === 2 ? "nav-link active" : "nav-link"}
                    onClick={() => {
                      setStatus(2);
                    }}
                  >
                    completed
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={status === -1 ? "nav-link active" : "nav-link"}
                    onClick={() => {
                      setStatus(-1);
                    }}
                  >
                    cancelled
                  </button>
                </li>
              </ul>
            </div>
          </div>
          {loading ? (
            <Loader colorChange="colorChange" />
          ) : list?.data?.length > 0 ? (
            list?.data?.map((item, i) => (
              <div className="col-sm-12 col-md-6 col-lg-4 mb-3" key={i}>
                <div className="BookingBox">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>
                      Order ID-<b>{item?.bookingId}</b>
                    </span>
                    <span
                      className={
                        item?.orderStatus === ""
                          ? "StatusBtn canceledStatus"
                          : item?.orderStatus === 1
                          ? "StatusBtn pendingStatus"
                          : item?.orderStatus === 2
                          ? "StatusBtn approvedStatus"
                          : item?.orderStatus === -1
                          ? "StatusBtn rejectedStatus"
                          : null
                      }
                    >
                      {item?.orderStatus === ""
                        ? "New"
                        : item?.orderStatus === 1
                        ? "Ongoing"
                        : item?.orderStatus === 2
                        ? "completed"
                        : item?.orderStatus === -1
                        ? "cancelled"
                        : null}
                    </span>
                  </div>
                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <div className="dateBoxColor">
                        <span className="dateFont">
                          {moment(item?.dateOfInspection).format("DD")}
                        </span>{" "}
                        {moment(item?.dateOfInspection).format("MMMM, YYYY")}
                      </div>
                    </div>
                    <div className="col-sm-9 col-md-9 col-lg-9">
                      <Link to={`/booking/detail/${item?._id}`}>
                        <p className="mb-0 bookingTitle">
                          {item?.propertyId?.propertyName
                            ? item?.propertyId?.propertyName
                            : item?.propertyName}
                        </p>
                        <p className="mb-0 ps-3 position-relative addresArea">
                          <img
                            src="assets/images/locatelocation.png"
                            alt=""
                            className="pinIcon"
                          />{" "}
                          {item?.location}
                        </p>
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="mb-0 ps-3 position-relative addresArea">
                            <img
                              src="assets/images/AreaPin.png"
                              alt=""
                              className="pinIcon"
                            />{" "}
                            Area: {item?.area}
                          </p>
                          <span className="BookingPlan">
                            Plan:{item?.packageId?.packageName}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center">No Booking Found</div>
          )}
          <div className="col-sm-12 col-md-12 col-lg-12 my-4">
            {!loading && list?.data?.length > 0 ? (
              <Paginations
                page={page}
                handlePage={handlePage}
                total={list?.count}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default MyBooking;
